import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-545634f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_user"
};
const _hoisted_2 = {
  class: "tag_boxs"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "box_imgs"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "del_o_1"
};
const _hoisted_8 = {
  key: 0,
  class: "jc_del"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0,
  class: "accord"
};
const _hoisted_11 = {
  key: 1,
  class: "noaccord"
};
const _hoisted_12 = {
  class: "ml-8 w-100"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "text-cut2 names"
};
const _hoisted_21 = {
  class: "time"
};
const _hoisted_22 = {
  key: 0,
  class: "last_time"
};
const _hoisted_23 = {
  key: 0,
  class: "loading"
};
const _hoisted_24 = {
  key: 1,
  class: "no-more"
};
import { ref } from "vue";
import { debounce } from "lodash";
import { getcustomer_list } from "@/service/modules/alllist";
import { useScrollLoad } from "@/hooks/useScrollLoad";
import { Search } from "@element-plus/icons-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["set_from"],
  setup(__props, {
    emit: __emit
  }) {
    const search = ref("");
    const actives = ref("");
    const scrollContainer = ref(null);
    const emit = __emit;
    const tag_list = ref([{
      name: "客户列表",
      id: 0
    }, {
      name: "流失客户",
      id: 1
    }]);
    const active_id = ref(0);
    const set_active = id => {
      active_id.value = id;
      reset();
    };
    // 使用滚动加载 Hook
    const {
      list,
      loading,
      hasMore,
      reset,
      loadData
    } = useScrollLoad({
      pageSize: 20,
      requestData: getcustomer_list,
      searchParams: () => {
        const params = {
          search: search.value // 动态获取搜索参数
        };
        // 仅在 active_id.value 不为 0 时添加 is_del
        if (active_id.value !== 0) {
          params.is_del = active_id.value;
        }
        return params;
      }
    });
    const handScroll = () => {
      if (!scrollContainer.value) return;
      // 获取滚动容器
      const container = scrollContainer.value;
      // 计算滚动位置
      const scrollTop = container.scrollTop; // 当前滚动距离
      const scrollHeight = container.scrollHeight; // 总高度
      const clientHeight = container.clientHeight; // 可视区高度
      if (scrollHeight - scrollTop - clientHeight <= 50) {
        loadData();
      }
    };
    // 设置选中的用户
    const set_actives = item => {
      actives.value = item.id;
      emit("set_from", item.external_userid);
    };
    // 搜索输入变化
    const changes = debounce(() => {
      reset();
    }, 300);
    const get_lasttime = item => {
      return active_id.value == 1 ? item.up_time ? item.up_time.slice(5, 19) : "" : item.last_chat_time ? item.last_chat_time.slice(5, 10) : "";
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
        class: "search",
        placeholder: "搜索客户昵称/备注",
        "prefix-icon": _unref(Search),
        onInput: _unref(changes),
        clearable: ""
      }, null, 8, ["modelValue", "prefix-icon", "onInput"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tag_list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item_tags", active_id.value == item.id ? 'active1' : 'no_active1']),
          key: index,
          onClick: $event => set_active(item.id)
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128))]), _createElementVNode("div", {
        class: "user_ops",
        ref_key: "scrollContainer",
        ref: scrollContainer,
        onScroll: handScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["user_item", item.id == actives.value ? 'bgc' : '']),
          onClick: $event => set_actives(item),
          key: index
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          class: "imgs_s",
          src: item.avatar,
          alt: ""
        }, null, 8, _hoisted_6), active_id.value != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [item.del_source == 'DELETE_BY_TRANSFER' ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 继承删 ")) : (_openBlock(), _createElementBlock("div", _hoisted_9, [item.del_type == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "主动删")) : _createCommentVNode("", true), item.del_type == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "被删除")) : _createCommentVNode("", true)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          placement: "top",
          disabled: active_id.value != 1
        }, {
          content: _withCtx(() => [item.del_source == 'DELETE_BY_TRANSFER' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [item.user && item.user.name ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.delete_time) + " @ " + _toDisplayString(item.user.name) + "在线继承自动删除该客户", 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [item.del_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [item.user && item.user.name ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.delete_time) + " @ " + _toDisplayString(item.user.name) + "删除了该客户", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.del_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [item.user && item.user.name ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.delete_time) + "删除了 @ " + _toDisplayString(item.user.name), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]))]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString(item.name) + _toDisplayString(item.remark ? `(${item.remark})` : ""), 1)]),
          _: 2
        }, 1032, ["disabled"]), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", {
          class: _normalizeClass(["tags", item.type == 1 ? 'color1' : 'color2'])
        }, " @" + _toDisplayString(item.type == 1 ? "微信" : "企微"), 3), item.last_chat_time || item.up_time ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(get_lasttime(item)), 1)) : _createCommentVNode("", true)])])], 10, _hoisted_4);
      }), 128)), _unref(loading) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [_createTextVNode("加载中...")])), [[_directive_loading, _unref(loading)]]) : _createCommentVNode("", true), !_unref(hasMore) && _unref(list).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 没有更多数据了 ")) : _createCommentVNode("", true)], 544)]);
    };
  }
});